module.exports = __webpack_public_path__ + "static/media/check-square.d552ceff.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icons/check-square.svg
// module id = 841
// module chunks = 21